import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MiniFooter } from '@app/src/common/MiniFooter';
import { ButtonsAction } from '@app/src/common/ButtonsAction';

import {
  PriceConceptWrapper,
  ButtonPrevWrapper,
  ButtonNextWrapper,
  ButtonActionsWrapper,
  Wrapper
} from './styled';
import { isClientEnv } from '@app/src/utils/validations';
import { useHistory, useParams } from 'react-router-dom';

const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  categoryConfig?: any;
  priceTotal?: number;
}

export const FormActions: React.FC<Props> = ({ categoryConfig, priceTotal }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { idPrint } = useParams();
  const [isFixedActionsButtons, setIsFixedActionsButtons] = useState(false);
  let active = false;
  const [isDisabledScroll, setIsDisabledScroll] = useState(false);
  const refWrapper = useRef(null);
  const refFooter = useRef(null);
  const prints = useSelector(state => state.summary.data.print);

  useEffect(() => {
    if (isClient) {
      if (window.innerWidth < BREAKPOINT) {
        window.addEventListener('scroll', handleScroll);
      }
      window.addEventListener('resize', handleResizeWindow);
      return () => {
        window.removeEventListener('resize', handleResizeWindow);
        if (window.innerWidth < BREAKPOINT) {
          window.removeEventListener('scroll', handleScroll);
        }
      }
    }
  }, []);

  const handleResizeWindow = useCallback(() => {
    if (window.innerWidth >= BREAKPOINT) {
      setIsFixedActionsButtons(false);
      window.removeEventListener('scroll', handleScroll)
    } else {
      window.addEventListener('scroll', handleScroll)
      if (active) {
        active = false;
      }
    }
  }, [dispatch]);

  const disabledScroll = () => {
    setIsDisabledScroll(false)
    setTimeout(() => {
      setIsDisabledScroll(true)
    }, 500)
  }

  const handleScroll = useCallback(() => {
    const bodyHeight = document.body.offsetHeight;
    const fixedElementHeight = refWrapper.current.offsetHeight;
    const footerHeight = refFooter.current.offsetHeight;

    if (!isDisabledScroll) {
      if ( bodyHeight - (window.pageYOffset + window.innerHeight) > fixedElementHeight && active === false) {
        active = true;
        setIsFixedActionsButtons(true);
        disabledScroll();
      }
      if ( bodyHeight - (window.pageYOffset + window.innerHeight) <= footerHeight && active === true) {
        active = false;
        setIsFixedActionsButtons(false)
        disabledScroll()
      }
    }
  }, [dispatch])

  const handleClickGoBack = () => {
    history.push(`${categoryConfig.link}-2`);
  }

  const handleClickNext = () => {
    pushDatalayer(categoryConfig.name);
    history.push(`${categoryConfig.link}-4/${idPrint}`);
  }

  const pushDatalayer = (categoryName: string) => {
    let printsTotal = 0;
    Object.keys(prints).forEach(key => {
      printsTotal = printsTotal + prints[key].dates.length;
    })
    if (isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Posting',
        'eventAction': `Paso 3 - ${categoryName}`,
        'eventLabel': `${printsTotal}|S/ ${priceTotal}`,
        'eventValue': 1
      })
    }
  }

  return (
    <Wrapper  ref={refWrapper}>
      <ButtonActionsWrapper fixed={isFixedActionsButtons} >
        <PriceConceptWrapper
          isDisplay={isFixedActionsButtons}
          bgColor={`rgba(${categoryConfig && categoryConfig.colorRgba}, .2)`}
          priceTotal={priceTotal} />
        <ButtonsAction
          ButtonPrev={
            <ButtonPrevWrapper
              handleClick={handleClickGoBack}
              background='white'
              color={categoryConfig.color}
              width={160}
              text="¿Dónde quieres publicar?"
              icon={{name:'icon-back', color: categoryConfig.color, width:'16'}}
              left
            />}
          ButtonNext={
            <ButtonNextWrapper
              handleClick={handleClickNext}
              background={categoryConfig.color}
              color="white"
              text="Siguiente"
              width={140}
              icon={{name:'icon-back', color: '#fff', width:'16'}}
            />}
          />
      </ButtonActionsWrapper>
      <MiniFooter refFooter={refFooter} />
    </Wrapper>
)};
